export function isIOS() {
    if (typeof navigator === 'undefined')
        return false;
    const ua = navigator.userAgent || '';
    const iOSUA = /iPad|iPhone|iPod/.test(ua);
    const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    return iOSUA || iPadOS;
}
